/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatternMatchType } from './PatternMatchType';
import {
    PatternMatchTypeFromJSON,
    PatternMatchTypeFromJSONTyped,
    PatternMatchTypeToJSON,
} from './PatternMatchType';
import type { PatternQualifier } from './PatternQualifier';
import {
    PatternQualifierFromJSON,
    PatternQualifierFromJSONTyped,
    PatternQualifierToJSON,
} from './PatternQualifier';

/**
 * 
 * @export
 * @interface RegexPasswordValidationRuleAllOf
 */
export interface RegexPasswordValidationRuleAllOf {
    /**
     * 
     * @type {string}
     * @memberof RegexPasswordValidationRuleAllOf
     */
    pattern: string;
    /**
     * 
     * @type {PatternMatchType}
     * @memberof RegexPasswordValidationRuleAllOf
     */
    match_type: PatternMatchType;
    /**
     * 
     * @type {Array<PatternQualifier>}
     * @memberof RegexPasswordValidationRuleAllOf
     */
    pattern_qualifiers?: Array<PatternQualifier>;
}

/**
 * Check if a given object implements the RegexPasswordValidationRuleAllOf interface.
 */
export function instanceOfRegexPasswordValidationRuleAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pattern" in value;
    isInstance = isInstance && "match_type" in value;

    return isInstance;
}

export function RegexPasswordValidationRuleAllOfFromJSON(json: any): RegexPasswordValidationRuleAllOf {
    return RegexPasswordValidationRuleAllOfFromJSONTyped(json, false);
}

export function RegexPasswordValidationRuleAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegexPasswordValidationRuleAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pattern': json['pattern'],
        'match_type': PatternMatchTypeFromJSON(json['match_type']),
        'pattern_qualifiers': !exists(json, 'pattern_qualifiers') ? undefined : ((json['pattern_qualifiers'] as Array<any>).map(PatternQualifierFromJSON)),
    };
}

export function RegexPasswordValidationRuleAllOfToJSON(value?: RegexPasswordValidationRuleAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pattern': value.pattern,
        'match_type': PatternMatchTypeToJSON(value.match_type),
        'pattern_qualifiers': value.pattern_qualifiers === undefined ? undefined : ((value.pattern_qualifiers as Array<any>).map(PatternQualifierToJSON)),
    };
}

